/**
 * Dependencies
 */
import { get } from 'lodash'

/**
 * Get the selected KPIs from the state
 *
 * @param  {Object} state [description]
 * @return {Array}       [description]
 */
const selectedKpis = (state) => {
    return get(state.data, 'project_display_kpis.data', [])
        .filter(item => item.selected)
        .map(item => item.key)
}

export default {
    selectedKpis
}



// WEBPACK FOOTER //
// ./src/state/modules/user/preferences/getters.js